import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const styles = `
  @keyframes slideInRight {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
  
  @keyframes slideOutRight {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(100%);
    }
  }
  
  .custom-drawer {
    animation-duration: 0.3s;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
  }
  
  .custom-drawer.open {
    animation-name: slideInRight;
  }
  
  .custom-drawer.closed {
    animation-name: slideOutRight;
  }
`;

const Drawer = ({ open = false,disableXbtn=false, onClose, children, titleForSideCard,minWidthForDrawer="50%" }) => {
  useEffect(() => {
    if (open) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [open]);

  return (
    <>
      <style>{styles}</style>
      <div
        className={`offcanvas offcanvas-end custom-drawer  p-0 ${
          open ? "open" : "closed"
        }`}
        style={{
          minWidth: minWidthForDrawer,
          visibility: open ? "visible" : "hidden",
        }}
      >
        {titleForSideCard && (
          <div className="generic-sideCardHeader">
           <div className="d-flex align-items-center w-100 justify-content-between">
             <h5 className="offcanvas-title w-100">{titleForSideCard}</h5>
           </div>
           <div className="d-inline-block float-end">
            { !disableXbtn && <button
                type="button"
                className="btn-close "
                aria-label="Close"
                onClick={onClose}
              ></button>}
           </div>

          </div>
        )}
        <div className="sideCardBody">{children}</div>
      </div>

      {open && (
        <div
          className="offcanvas-backdrop fade show"
          style={{
            opacity: 0.3,
            transition: "opacity 0.15s linear",
          }}
          onClick={onClose}
        />
      )}
    </>
  );
};

const GenericOverviewSideCard = ({
  showMoreModal,
  setShowMoreModal,
  titleForSideCard,
  comp = <></>,
  minWidthForDrawer,
  disableXbtn
}) => {
  return (
    <div className="row">
      <Drawer
        open={showMoreModal}
        onClose={() => setShowMoreModal(false)}
        titleForSideCard={titleForSideCard}
        minWidthForDrawer={minWidthForDrawer}
        disableXbtn={disableXbtn}
      >
        {comp}
      </Drawer>
    </div>
  );
};

export default GenericOverviewSideCard;
